import { useEffect } from "react";
import { SITE } from "@/content/site";
import { useLang } from "@/i18n";

const BookingPage = () => {
  const { t } = useLang();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = SITE.fitco.scriptUrl;
    script.defer = true;
    script.dataset.fitcoHome = "true";
    script.setAttribute("establishmentid", SITE.fitco.establishmentId);
    script.setAttribute("calendarpath", SITE.fitco.calendarPath);
    script.setAttribute("planspath", SITE.fitco.plansPath);
    script.setAttribute("profilebuttonselector", SITE.fitco.profileButtonSelector);
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <main className="bg-ivory px-6 pb-24 pt-32 md:px-12 md:pt-40">
      <div className="mx-auto max-w-[1600px]">
        <h1 className="font-display text-5xl leading-[0.95] tracking-tight text-charcoal sm:text-6xl lg:text-7xl">{t.booking.titleA} <span className="italic font-light">{t.booking.titleB}</span></h1>
        <div className="mt-16"><div id="fitcoCalendar" /></div>
        <div className="mt-20"><div id="fitcoPlans" /></div>
        <section id="cancellation-policy" data-testid="cancellation-policy" className="mt-24 max-w-3xl border-t border-charcoal/15 pt-16 md:mt-32 md:pt-20">
          <h2 className="font-display text-4xl leading-none tracking-tight text-charcoal sm:text-5xl">{t.booking.cancellation.title}</h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-charcoal/70 md:text-lg">
            <p>{t.booking.cancellation.intro}</p>
            <p>{t.booking.cancellation.notice}</p>
            <p className="border-l border-gold pl-5 text-sm leading-relaxed text-charcoal/65 md:text-base">{t.booking.cancellation.fee}</p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default BookingPage;
